import {YAMETRIKA_ID} from "../Config";

export default function useMetrika() {
    const ym = (window as any).ym;

    const ymb = (eventName: string|undefined|null, params?: any) => {
        if(ym && eventName){
            if(params){
                ym(YAMETRIKA_ID, 'reachGoal', eventName, params);
            }else{
                ym(YAMETRIKA_ID, 'reachGoal', eventName);
            }
            console.log(`Yandex Metrika: Event "${eventName}" sent`, params);
        }
    }

    return {ymb}
}